import { AxiosInstance } from 'axios';
import { sessionMonitor } from './sessionMonitor';

const INSTALLED_FLAG = '__enaraSessionInterceptorInstalled';

/**
 * Report auth-shaped HTTP failures to the session monitor.
 *
 * Deliberately a *response error* interceptor that re-rejects the original
 * error untouched: an interceptor runs before the caller's `catch`, so no call
 * site has to change, and swallowing or transforming the error here would
 * silently change behaviour across the entire app.
 *
 * Idempotent, so double-installing on the same instance is harmless.
 */
export const installSessionInterceptor = (instance: AxiosInstance): AxiosInstance => {
  const flagged = instance as AxiosInstance & { [INSTALLED_FLAG]?: boolean };
  if (flagged[INSTALLED_FLAG]) {
    return instance;
  }
  flagged[INSTALLED_FLAG] = true;

  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      try {
        sessionMonitor.reportSuspiciousFailure(error);
      } catch (monitorError) {
        // A bug in the monitor must never break HTTP for the whole app.
      }
      return Promise.reject(error);
    }
  );

  return instance;
};
